import { Fragment } from "react/jsx-runtime";
import { spacing } from "src/design-system/tokens/spacing";
import ChevronRight from "src/design-system/icons/ChevronRight.svg?react";
import { iconSize } from "src/theme";
import type { Mode } from "src/utils/types/mode";
import styled from "styled-components";
import { TransitIcon } from "src/design-system/components/TransitIcon/TransitIcon";

export function TripCardModes({
  separator = true,
  majorModes,
  duration,
}: {
  majorModes: Mode[];
  duration?: number;
  separator?: boolean;
}) {
  return (
    <TransitIcons $gap={!separator}>
      {majorModes.map((mode, i) => {
        return (
          <Fragment key={i}>
            {separator && i !== 0 && (
              <Separator>
                <ChevronRight />
              </Separator>
            )}
            <TripCardIconWrapper rotation={getTransitModeRotation(mode)}>
              <TransitIcon mode={mode} className="w-4" />
            </TripCardIconWrapper>
          </Fragment>
        );
      })}
    </TransitIcons>
  );
}

function getTransitModeRotation(transitMode: Mode): string | undefined {
  const rotations: { [key in Mode]?: string } = {
    plane: "90deg",
  };
  return rotations[transitMode];
}

const Separator = styled.div`
  display: flex;
  align-items: center;
  margin: 0 ${spacing.xs};

  svg {
    display: inline-block;
    height: 8px;
    width: auto;
  }
`;

const TransitIcons = styled.div<{ $gap: boolean }>`
  display: flex;
  align-items: center;
  ${({ $gap }) => $gap && `gap: ${spacing.lg};`}
`;

const TripCardIconWrapper = styled.div<{ rotation?: string }>`
  width: ${iconSize.sm};
  height: auto;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  svg {
    max-width: 100%;
    height: auto;
    ${({ rotation }) => rotation && `transform: rotate(${rotation});`}
  }
`;
